export class DistributionItemModel {
	public cost: number;
	public totalUnits: number;
	public size: number;
	public originalSize: number;
	public unit: string;
	public editing?: boolean;

	constructor(json?: Partial<DistributionItemModel>) {
		if (json) {
			Object.assign(this, json);
		}
	}
}
